module.exports = __webpack_public_path__ + "static/media/thumbnail-robotMiddle.8aa1734d.png";